import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { underwritingQueueService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UseUnderwritingClaimMutationProps = {
	id: string;
	onSuccessHandler?: Function;
};

const useUnderwritingClaimMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({ id }: UseUnderwritingClaimMutationProps) => {
			dispatch(uiActions.showSpinnerOverlay());

			return underwritingQueueService.claimToCurrentUser({ id });
		},
		{
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
			onSuccess(data, { onSuccessHandler }) {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Claim has been updated successfully",
					}),
				);
				onSuccessHandler?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useUnderwritingClaimMutation;
